import { Link, Typography } from '@mui/material';
import * as S from './PageTitle.styled';
import { PageTitlePropsType } from './PageTitle.types';

export function PageTitle(props: PageTitlePropsType) {
  const { streamUiBaseUrl, streamHandle, examSessionUuid, partnerTargetProfile, partnerName } =
    props;

  const streamPath = streamUiBaseUrl + '/streams/' + streamHandle;
  return (
    <S.Card>
      <Typography variant='h6'>Exam Session: {examSessionUuid}</Typography>
      <Typography variant='h6'>
        Stream Handle:{' '}
        <Link underline='none' href={streamPath}>
          {streamHandle}
        </Link>
      </Typography>
      <Typography variant='h6'>{partnerName}</Typography>
      <Typography variant='h6'>
        Current Partner Target Config:{' '}
        <Link underline='none' href={`#${partnerTargetProfile}`}>
          {partnerTargetProfile}
        </Link>
      </Typography>
    </S.Card>
  );
}
